<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Configurações'" :novo="novo" :titulo="'Configurações: ' + contentEdit.idioma" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-12 form-group">
          <label>Idioma:</label>
          <input
            type="text"
            v-model="contentEdit.idioma"
            name="idioma"
            id="idioma"
            class="form-control required valid"
            value
            readonly
          />
        </div>
        <div class="clearfix"></div>
        <div class="col-12"> 
          <hr>
          <h4>Configurações cabeçalho</h4>
        </div>
        <div class="col-4 form-group">
          <label>Menu Home:</label>
          <input
            type="text"
            v-model="contentEdit.menu1"
            name="menu1"
            id="menu1"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Menu Quem Somos:</label>
          <input
            type="text"
            v-model="contentEdit.menu2"
            name="menu2"
            id="menu2"
            class="form-control required valid"
            value
          />
        </div>

        <div class="col-4 form-group">
          <label>Menu Segmentos:</label>
          <input
            type="text"
            v-model="contentEdit.menu3"
            name="menu3"
            id="menu3"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Menu Clientes:</label>
          <input
            type="text"
            v-model="contentEdit.menu4"
            name="menu4"
            id="menu4"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Menu Artigos:</label>
          <input
            type="text"
            v-model="contentEdit.menu5"
            name="menu5"
            id="menu5"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Menu Contato:</label>
          <input
            type="text"
            v-model="contentEdit.menu6"
            name="menu6"
            id="menu6"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-12"> 
          <hr>
          <h4>Configurações rodapé</h4>
        </div>
       
        <div class="col-12 form-group">
          <label>Frase direitos:</label>
          <input
            type="text"
            v-model="contentEdit.fraseDireitos"
            name="fraseDireitos"
            id="fraseDireitos"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-12"> 
          <hr>
          <h4>Logotipos</h4>
        </div>
        <div class="col-sm-6"><label>Logotipo cabeçalho:</label></div>
        <div class="col-sm-6"><label>Logotipo rodapé:</label></div>
          <div class="col-sm-6 text-center">
          
           <div
              class="areaFoto"
              :class="contentEdit.logotipoCabecalho? 'ativo':''"
              @click="$refs.logotipoCabecalho.click()"
              :style="contentEdit.logotipoCabecalho && carregado? 'background:url(' + contentEdit.logotipoCabecalho+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="logotipoCabecalho"
                name="logotipoCabecalho"
                ref="logotipoCabecalho"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="contentEdit.logotipoCabecalho"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('logotipoCabecalho',1)"
            >Remover foto</button>
          </div>
          <div class="col-sm-6 text-center">
          
           <div
              class="areaFoto"
              :class="contentEdit.logotipoRodape? 'ativo':''"
              @click="$refs.logotipoRodape.click()"
              :style="contentEdit.logotipoRodape && carregado? 'background:url(' + contentEdit.logotipoRodape+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="logotipoRodape"
                name="logotipoRodape"
                ref="logotipoRodape"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="contentEdit.logotipoRodape"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('logotipoRodape',2)"
            >Remover foto</button>
          </div>
        <div class="col-12"> 
          <hr>
          <h4>Páginas</h4>
        </div>
        <div class="col-12"> 
          <hr>
          <h5>Artigos</h5>
        </div>
        <div class="col-4 form-group">
          <label>Título artigos:</label>
          <input
            type="text"
            v-model="contentEdit.tituloArtigos"
            name="tituloArtigos"
            id="tituloArtigos"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Subtítulo artigos:</label>
          <input
            type="text"
            v-model="contentEdit.subtituloArtigos"
            name="subtituloArtigos"
            id="subtituloArtigos"
            class="form-control required valid"
            value
          />
        </div>
         
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData,getSuccess,getError,urlApi } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error:null,
      contentFotos: [],
      carregado:true,
      files: [],
      logotipoCabecalho: [],
      logotipoRodape: [],
      contentEdit: {
        titulo:'',
        ativo: false,
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]

    };
  },
  components: { Tbheader  },
  methods: {
OnFileSelected(event) {
      if (event.target.id == "logotipoCabecalho") {
        this.contentEdit.logotipoCabecalho = URL.createObjectURL(event.target.files[0]);
        this.logotipoCabecalho = event.target.files[0];
       this.carregado = true;
      } else if (event.target.id == "logotipoRodape") {
        this.contentEdit.logotipoRodape = URL.createObjectURL(event.target.files[0]);
        this.logotipoRodape = event.target.files[0];
        this.carregado = true;
      } 
    },
    fnRemoveFoto(tipo, i) {
      var filename = '';
        if (i == 1) {
          filename = this.contentEdit.logotipoCabecalho.split('/').pop().split('#')[0].split('?')[0]
          this.contentEdit.logotipoCabecalho = null;
        } else if (i == 2) {
          filename = this.contentEdit.logotipoRodape.split('/').pop().split('#')[0].split('?')[0]
          this.contentEdit.logotipoRodape = null;
       } 
      this.$http
        .delete("gape/upload/gape/config/" + this.contentEdit.idioma + "/" +filename +"/arquivo")
        .then((res) => {
          console.log(res);
        });

    },
   GetFilename(url)
    {
      if (url)
      {
          var m = url.toString().match(/.*\/(.+?)\./);
          if (m && m.length > 1)
          {
            return m[1];
          }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if(this.logotipoCabecalho.name != undefined){
       fd.append("files", this.logotipoCabecalho, this.logotipoCabecalho.name);
      }
      if(this.logotipoRodape.name != undefined){
       fd.append("files", this.logotipoRodape, this.logotipoRodape.name);
      }
      this.$http
        .post("gape/upload/gape/" + this.contentEdit.idioma +"/config", fd)
        .then(() => {
          this.carregado = true;


        });
    },
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: `/gape/configuracoes/`})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''
      const imgUrl =
      urlApi + "Upload/gape/"  + this.contentEdit.idioma + "/config/";
      var chamaUpload = false;
      if(this.logotipoCabecalho.name != undefined){
        chamaUpload = true;
        this.contentEdit.logotipoCabecalho  = imgUrl + this.logotipoCabecalho.name;
      }
      if(this.logotipoRodape.name != undefined){
       chamaUpload = true;
       this.contentEdit.logotipoRodape  = imgUrl + this.logotipoRodape.name;
      }

       let data = await this.$http[metodo]("/gape/configuracoes" + completaUrl,this.contentEdit)
        .then(() =>{
          if(chamaUpload){
            this.OnUpload();
          }
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"gape/configuracoes/"+valueId);
      this.contentEdit = data[0].content;
      this.fnCarregaIdiomas(valueId);
      this.$vs.loading.close()
    },   
    async fnCarregaIdiomas(valueId) {
      let data = await getData(this.urlApi+"gape/idiomas/"+valueId);
      console.log(data);
      this.contentEdit.idioma = data[0].content.abreviacao;
    },   

  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,#editor2,#editor3{
	min-height: 50vh;
}
</style>